import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { Redirect, Route, Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import EmployeeEdit from './EditEmployeeForm'
import EmployeeNew from './NewEmployeeForm'
import {
  employeeRouteNewShop,
  employeesRoute,
  employeesRouteEdit,
  employeesRouteEditFallback,
  employeesRouteNew,
  employeesRouteNewFallback,
  notFoundRoute
} from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler('/companies'))

export const EmployeeContainer: React.FC = () => {
  return (
    <Switch>
      <Route exact path={employeesRouteNew} component={EmployeeNew} />
      <Route exact path={employeesRouteEdit} component={EmployeeEdit} />
      <Redirect exact path={employeeRouteNewShop} to={employeesRouteNewFallback} />
      <Redirect exact path={employeesRoute} to={employeesRouteEditFallback} />
      <Redirect to={notFoundRoute} />
    </Switch>
  )
}

export default enhance(EmployeeContainer)
